module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2n7n4n-bb1275fd1d807f26a162b20f6ed46c8a.svg";